// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"shareUrlPopUp__gradient-bg5__wwf9p","sharePopUp":"shareUrlPopUp__sharePopUp__t3idw"};